import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconUtils } from '@/common/utils/IconUtils'

export const EnumCellRenderer = ({ value, colDef }) => {

  if (!value) {
    return <span />
  }

  const enumSpec = colDef.values.find(enumSpec => enumSpec.code === value);
  if (!enumSpec) {
    console.error('Unable to find EnumSpec for value: ' + value + ', enumType: ' + colDef.enumType + ', field: ' + colDef.field);
  }
  return (
    <>
      {enumSpec.icon &&
        <FontAwesomeIcon
          style={{ marginRight: '4px' }}
          icon={IconUtils.iconFromIconStr(enumSpec.icon)}
          color={enumSpec.color}
          spin={enumSpec.icon.includes('spinner')}
        />
      }
      {enumSpec.displayName}
    </>
  )
}